import * as type from "./constants";
const initialState = {
  loading: false,
  funds: {},
};

export default function createPerformanceMetrix(state = initialState, action) {
  switch (action.type) {
    case type.CREATE_PERFORMANCE_MATRIX_INIT:
      return { ...state };
    case type.CREATE_PERFORMANCE_MATRIX_SUCCESS:
      return { ...state, funds: action.payload };
    case type.CREATE_PERFORMANCE_MATRIX_FAILED:
      return { ...state };
    default:
      return state;
  }
}
